import { defineStore } from 'pinia'
import { FileApi, TrashApi } from '../test-api/index.ts'
import axios from 'axios'
import findIndex from 'lodash/findIndex'
import useBcSearchStore from './bcSearch'
import handleApiError from '../utils/handleApiError'

const fileApi = new FileApi({}, '/api/v2')
const trashApi = new TrashApi({}, '/api/v2')
let cancelationToken
const CancelToken = axios.CancelToken;
const bcSearchStore = useBcSearchStore()

const state = () => ({
  loading: true, // is document loading now?
  list: [],
  limit: 100,
  offset: 0,
  view: 'grid',
  deleted: false,
  modalSearch: false,
  query: null,
  order: 'uploaded',
  dir: 'desc',
})

// functionName: (state, getters, rootState) => {}
const getters = {
  q() {
    return this.modalSearch ? this.query : bcSearchStore.query
  }
}

// functionName ({ commit, state, dispatch }, param, ...) {}
const actions = {
  showDeleted(deleted) {
    if (deleted === this.deleted) {
      return
    }

    this.modalSearch = false
    this.deleted = deleted
    this.list = []
    this.offset = 0
    this.limit = 100
  },
  showModalSearch(modalSearch, limit = 100) {
    if (modalSearch === this.modalSearch) {
      return
    }

    this.deleted = false
    this.modalSearch = modalSearch
    this.list = []
    this.offset = 0
    this.limit = limit
  },
  async loadFiles() {
    this.loading = true

    if (cancelationToken !== undefined) {
      cancelationToken.cancel();
      cancelationToken = undefined
    }

    cancelationToken = CancelToken.source()
    let fileListResponse
    if (this.deleted) {
      fileListResponse = await handleApiError(() => trashApi.trashFileList(this.q ? this.q : undefined, this.limit, this.offset, {
        cancelToken: cancelationToken.token
      }))
    } else {
      fileListResponse = await handleApiError(() => fileApi.fileList(this.q ? this.q : undefined, this.limit, this.offset, this.order, this.dir, {
        cancelToken: cancelationToken.token
      }))
    }

    this.list = this.list.concat(fileListResponse.data)
    this.loading = false
  },
  toggleView () {
    if (this.view === 'grid') {
      this.view = 'table'
    } else {
      this.view = 'grid'
    }
  },
  updateFile(file) {
    const index = findIndex(this.list, ['id', file.id])
    if (index !== -1) {
      this.list.splice(index, 1, file)
    }
  },
  deleteFile(fileId) {
    const index = findIndex(this.list, ['id', fileId])
    if (index !== -1) {
      this.list.splice(index, 1)
    }
  },
}

export default defineStore({
  id: 'bcFile',
  state,
  getters,
  actions
})
